export const COMPONENT = '/domain/component'
export const COMPONENT_HIGH_GROUP = '/domain/component-high-group'
export const COMPONENT_HIGH_GROUP_LIST = '/domain/component-high-group/list'
export const COMPONENT_LIST = '/domain/component/list'
export const COMPONENT_OPTIONS = '/domain/component/options'
export const COMPONENT_SEARCH = '/domain/component/search'
export const COMPONENT_VARIANT_OPTIONS = '/domain/component-variant/options'
export const COMPONENT_VARIANT_SEARCH = '/domain/component-variant/search'
